import { createContext } from 'react'

export const blackCardContext = createContext({
	isHovered: false,
	setIsHovered: () => {},
})
